import { ArslActionRemoveRow, ArsListingState } from "../interface";

/**
 * Removes a listing body row when more than one row remains.
 *
 * @param state - Current ARS listing state
 * @param action - Remove-row action identifying the target row
 * @returns Updated ARS listing state, or the original state when removal is not allowed
 */
export const arsl_removeRow = <T>(
  state: ArsListingState<T>,
  action: ArslActionRemoveRow,
): ArsListingState<T> =>
  state.bodyData.arsBodyRows.length <= 1
    ? state
    : {
        ...state,
        changed: true,
        bodyData: {
          ...state.bodyData,
          arsBodyRows: state.bodyData.arsBodyRows.filter((row) => row.id !== action.rowId),
        },
      };
